import get from 'lodash/get'

export const createFeatureSelector = featureName => state =>
  get(state, featureName)
